import type { FormField } from '../../types';
import {
  validateQuestionImage,
  validateQuestionStructuredValue,
  type ImageClickMapAnswerValue,
} from '../../lib/question-blocks';
import { SignaturePreview } from '../conversation/SignaturePreview';

/** Read-only visual companion to the plain-text stored answer. */
export function StructuredAnswerVisual({ field, value }: { field?: FormField; value: unknown }): React.ReactElement | null {
  if (!field || !['signature', 'image_click_map'].includes(field.type)) return null;
  const validated = validateQuestionStructuredValue(field, value);
  if (!validated.valid) return null;
  if (field.type === 'signature') {
    return <SignaturePreview value={validated.value} />;
  }
  if (field.type === 'image_click_map' && field.image && validateQuestionImage(field.image).length === 0) {
    const answer = validated.value as ImageClickMapAnswerValue;
    return <div className="relative mt-3 inline-block max-w-md overflow-hidden rounded-lg">
      <img src={field.image.imageUrl} alt={field.image.alt} className="block h-auto w-full" />
      {answer.points.map((point, index) => <span key={index}
        aria-label={`Point ${index + 1}: ${Math.round(point.x * 100)}%, ${Math.round(point.y * 100)}%`}
        className="absolute flex h-6 w-6 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-volt text-sm font-medium text-volt-foreground"
        style={{ left: `${point.x * 100}%`, top: `${point.y * 100}%` }}>{index + 1}</span>)}
    </div>;
  }
  return null;
}
